import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthState from '@/states/auth.state';
import useTenantState from '@/states/tenant.state';
import { initKeycloak } from '@/utils/auth/keycloak-instance';

const Callback = () => {
  const navigate = useNavigate();
  const { handleCallback } = useAuthState();
  const { setCurrentTenant } = useTenantState();
  const { tenants } = useAuthState();
  const tenantId = localStorage.getItem('initial-tenant-id');

  useEffect(() => {
    if (tenantId) {
      // Sync tenant state with URL
      const tenant = tenants?.find(t => t.slug === tenantId);
      if (tenant) {
        setCurrentTenant(tenant);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenants, setCurrentTenant]);

  useEffect(() => {
    const handleAuthCallback = async () => {
      // Initialize Keycloak to complete the authentication flow
      try {
        const authenticated = await initKeycloak(
          async () => {
            // On successful authentication
            console.log('Keycloak authentication completed');
            await handleCallback(); // Keycloak manages tokens internally
            localStorage.removeItem('initial-tenant-id');
            navigate(tenantId ? `/${tenantId}` : '/workspaces');
          },
          (error) => {
            console.error('Keycloak callback error:', error);
            navigate('/login');
          },
        );

        if (!authenticated) {
          console.error('Keycloak authentication failed');
          navigate('/login');
        }
      } catch (error) {
        console.error('Error during Keycloak callback:', error);
        navigate('/login');
      }
    };

    handleAuthCallback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      Validating your authentication...
    </div>
  );
};

export default Callback;
